<template lang="pug">
    v-dialog(v-model="isAgreementDialog" full-width persistent)
        div.agreementWrapper
            div
                p
                    | Any individual with assigned access to Chill Meditation web
                    | application (the "Tester") will not disclose any information or technology related to or found on
                    | the website www.chillanywhere.com (the "Software") or any comments regarding the Software to any
                    | third party without the prior written approval of Chill Meditation ("Chill"). The
                    | Tester will maintain the confidentiality of Software with at least the same degree of care that
                    | you use to protect your own confidential and proprietary information, but not less than a
                    | reasonable degree of care under the circumstances. The Tester will not be liable for the
                    | disclosure of any confidential information which is:
                    | (a) in the public domain other than by a breach of this Agreement on Tester’s part; or (b)
                    | rightfully received from a third party without any obligation of confidentiality; or (c)
                    | rightfully known to Tester without any limitation on use or disclosure prior to its receipt
                    | from Chill; or (d) generally made available to third parties by Chill without restriction on
                    | disclosure.

                p.text-xs-center
                    // I agree button
                    button-component.mt-5.accept(
                        :action="closeAgreementDialog"
                        color="grey"
                        large
                        outline
                    ) {{ $t('general.iAccept') }}
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Button from '~components/Button';
    import Separator from '~components/Separator';

    export default {
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapGetters('modals', ['isAgreementDialog', 'isWelcomeDialog'])
        },
        async beforeMount() {
            /**
             * Check if localStorage was last time updated today or not.
             */
            function isLastUpdateToday() {
                return window.localStorage.getItem('agreementDialog') !== null;
            }

            // Check if today show introduction video
            if (
                isLastUpdateToday() &&
                window.localStorage.getItem('agreementDialog') !== null
            ) {
                // Not show Dialog
            } else {
                window.localStorage.setItem('agreementDialog', new Date());

                this.setAgreementDialog();
            }
        },
        methods: {
            ...mapActions('modals', ['setAgreementDialog', 'setWelcomeDialog']),

            /**
             * Close Agreement Dialog
             */
            closeAgreementDialog() {
                // Set isAgreementDialog to false
                this.setAgreementDialog();
                // Set isWelcomeDialog to false
                this.setWelcomeDialog();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .agreementWrapper
        display: flex
        align-items: center
        height: 100vh
        padding: 40px 160px
        background-color: #022341

        .accept
            text-transform: none

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .agreementWrapper
            padding: 40px 60px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .agreementWrapper
            padding: 20px 20px
</style>
